import { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores';
import WhatsAppMetaConnectPage from '@/views/pages/whatsapp-meta/WhatsAppMetaConnectPage.vue';
import WhatsAppMetaListPage from '@/views/pages/whatsapp-meta/WhatsAppMetaListPage.vue';
import WhatsAppMetaDetailPage from '@/views/pages/whatsapp-meta/WhatsAppMetaDetailPage.vue';

const requiresMetaFeature = () =>
    useAuthStore().userModel?.hasWhatsAppMeta ? true : { name: 'Integration' };

const whatsappMetaRouter: RouteRecordRaw = {
    name: 'WhatsAppMeta',
    path: 'whatsapp-meta',
    children: [
        {
            name: 'ListWhatsAppMeta',
            path: '',
            component: WhatsAppMetaListPage,
            beforeEnter: requiresMetaFeature,
        },
        {
            name: 'ConnectWhatsAppMeta',
            path: 'connect',
            component: WhatsAppMetaConnectPage,
            beforeEnter: requiresMetaFeature,
        },
        {
            name: 'WhatsAppMetaDetail',
            path: ':wabaId',
            component: WhatsAppMetaDetailPage,
            beforeEnter: requiresMetaFeature,
        },
    ],
};

export default whatsappMetaRouter;
